// Full site copy in English and Spanish. Keys are shared across languages.
// Arrays are returned as-is by t() — keep EN and ES arrays the same length/order.

export const translations = {
  en: {
    "nav.home": "Home",
    "nav.about": "About",
    "nav.menus": "Menus",
    "nav.gallery": "Gallery",
    "nav.weddings": "Weddings",
    "nav.work": "Work With Us",
    "nav.quote": "Request a Quote",

    "hero.eyebrow": "Private Dining · Rutland & the East Midlands",
    "hero.h1a": "Private chef dining,",
    "hero.h1b": "in the comfort",
    "hero.h1c": "of your",
    "hero.h1d": "home.",
    "hero.sub": "Restaurant-quality Spanish, Mediterranean & Italian cuisine, prepared exclusively for you and your guests.",
    "hero.badge": "Based in Rutland, serving Stamford & the surrounding East Midlands",
    "hero.plan": "Plan Your Private Dining Experience",
    "hero.menus": "Explore Our Menus",

    "chef.eyebrow": "Meet Your Private Chef",
    "chef.role": "Private Chef & Founder",
    "chef.p1": "My passion is simple: creating exceptional food and memorable experiences for people to enjoy together.",
    "chef.p2": "My culinary journey has taken me through professional kitchens including Sushi Social in Reykjavík, The George of Stamford, The Black Horse and The Bull in Market Deeping. These experiences have shaped the way I approach food today — combining professional technique with the relaxed, personal atmosphere of dining at home.",
    "chef.p3": "Mediterranean Palate was created to bring that experience directly to you. No busy restaurant, no fixed timetable and no need to spend your evening in the kitchen. Just great food, your favourite people and an experience designed around your occasion.",
    "chef.specialities": "Specialities",
    "chef.specval": "Spanish • Mediterranean • Italian",
    "chef.based": "Based In",
    "chef.basedval": "Rutland, UK",

    "occasions.items": [
      { title: "Birthday Celebrations", body: "Celebrate with exceptional food and your favourite people, without worrying about the cooking." },
      { title: "Hen Parties", body: "Make your hen weekend memorable with a private dining experience created especially for your group." },
      { title: "Anniversaries", body: "Enjoy a restaurant-quality evening without leaving the comfort of your home." },
      { title: "Dinner Parties", body: "Spend time with your guests rather than spending the evening in the kitchen." },
      { title: "Holiday Homes", body: "Make your stay even more special with a private chef experience at your accommodation." },
      { title: "Corporate Dining", body: "A relaxed and memorable dining experience for clients, colleagues and teams." },
    ],

    "teaser.eyebrow": "Mediterranean Weddings",
    "teaser.h2a": "Mediterranean weddings,",
    "teaser.h2b": "perfectly served.",
    "teaser.p1": "From the first canapé to the final dance, we bring together everything you need for an unforgettable wedding celebration.",
    "teaser.p2": "Your wedding should feel effortless. From beautifully presented canapés and a bespoke wedding menu to professional waiting staff, bar service, table service, music and entertainment, we can help bring your entire celebration together.",
    "teaser.btn": "Explore Our Weddings",

    "wflow.chips": ["Chef", "Canapés", "Waiting Staff", "Bar", "Table Service", "Entertainment", "DJ"],

    "gallery.eyebrow": "A Taste of Mediterranean Palate",
    "gallery.h2a": "A glimpse into our",
    "gallery.h2b": "food",
    "gallery.h2c": "",
    "gallery.cta1k": "Explore",
    "gallery.cta1": "View Our Menus",
    "gallery.cta2k": "Begin",
    "gallery.cta2": "Request a Quote",
    "gallery.cta3": "View Our Gallery",
    "gallery.cta3k": "Discover",

    "footer.tagline": "Private Chef Dining Experiences",
    "footer.contact": "Contact",

    "wa.label": "Chat With Your Chef",
    "wa.msg": "Hi Santiago, I'd love to enquire about a private dining experience.",

    "menus.h2a": "Explore Our",
    "menus.h2b": "Menus",
    "menus.bespokeH": "Don't see your perfect menu?",
    "menus.bespokeP": "Every experience can be completely bespoke. Tell us what you're looking for and we'll create something especially for you.",
    "menus.bespokeBtn": "Create My Bespoke Menu",
    "menucats": [
      { group: "Spanish & Mediterranean", items: [
        { label: "Flavours of Spain", id: "flavours-of-spain" },
        { label: "Tapas", id: "tapas-sharing" },
        { label: "Mediterranean BBQ", id: "mediterranean-bbq" },
        { label: "Tasting Menu", id: "tasting-menu" },
      ]},
      { group: "Italian", items: [
        { label: "Italian Four Course", id: "italian-4-course" },
        { label: "La Dolce Vita", id: "la-dolce-vita" },
      ]},
      { group: "British", items: [
        { label: "The English Table", id: "the-english-table" },
        { label: "Sunday Roast", id: "sunday-roast" },
        { label: "Classic British BBQ", id: "classic-british-bbq" },
      ]},
      { group: "Celebrations", items: [
        { label: "Canapé Party", id: "canape-party" },
        { label: "Grazing Table", id: "grazing-table" },
        { label: "Vegetarian Experiences", id: "vegetarian" },
      ]},
    ],

    "quote.eyebrow": "Plan Your Experience",
    "quote.h1a": "Plan your private",
    "quote.h1b": "dining experience.",
    "quote.intro": "Tell us a little about your occasion and we'll be in touch to create a bespoke experience for you.",
    "quote.l.name": "Name", "quote.l.email": "Email", "quote.l.phone": "Phone", "quote.l.date": "Date",
    "quote.l.guests": "Number of Guests", "quote.l.occasion": "Occasion", "quote.l.location": "Location",
    "quote.l.menu": "Menu Preference", "quote.l.dietary": "Dietary Requirements", "quote.l.info": "Additional Information",
    "quote.p.name": "Your name", "quote.p.email": "you@email.com", "quote.p.phone": "Optional", "quote.p.guests": "e.g. 8",
    "quote.p.occasion": "e.g. Birthday, Anniversary", "quote.p.location": "Town / venue",
    "quote.p.menuDefault": "Not sure / bespoke", "quote.p.dietary": "Allergies, preferences…", "quote.p.info": "Tell us about your occasion…",
    "quote.submit": "Request My Bespoke Quote",
    "quote.sending": "Sending",
    "quote.successH": "Request received.",
    "quote.successP": "Your enquiry is with us — expect a note from our chef shortly.",
    "quote.successBtn": "Send another enquiry",
    "quote.thanks": "Thank you,",
    "toast.needName": "Please add your name and email.",
    "toast.okQuote": "Thank you — we'll be in touch to create your bespoke experience.",
    "toast.err": "Something went wrong. Please try again.",

    "work.eyebrow": "Join The Kitchen",
    "work.h1a": "Work with",
    "work.h1b": "us.",
    "work.intro": "Chefs, waiting and bar staff — if you share our love of great food and warm hospitality, we'd love to hear from you.",
    "work.l.name": "Name", "work.l.email": "Email", "work.l.phone": "Phone Number", "work.l.info": "Additional Info", "work.l.cv": "Attach CV",
    "work.p.name": "Your name", "work.p.email": "you@email.com", "work.p.phone": "Your phone number",
    "work.p.info": "Your experience, availability, the role you're interested in…", "work.p.cv": "Upload your CV (PDF, DOC, DOCX)",
    "work.submit": "Submit Application",
    "work.successH": "Application sent.",
    "work.successP": "We've received your details and will be in touch if there's a good fit.",
    "toast.okWork": "Thank you — your application has been sent.",

    "wpage.eyebrow": "Weddings · Rutland & the East Midlands",
    "wpage.h1a": "Mediterranean weddings,",
    "wpage.h1b": "perfectly served.",
    "wpage.sub": "From the first canapé to the final dance, we bring together everything you need for an unforgettable wedding celebration.",
    "wpage.plan": "Plan Your Wedding",
    "wpage.introH2a": "Your wedding should feel",
    "wpage.introH2b": "effortless.",
    "wpage.introP1": "Mediterranean Palate can provide a complete dining and event experience, tailored around your vision, your guests and your venue.",
    "wpage.introP2": "From beautifully presented canapés and a bespoke wedding menu to professional waiting staff, bar service, table service, music and entertainment, we can help bring your entire celebration together. The aim is simple: allow you to enjoy your day rather than worry about food and service.",
    "wpage.finalQuote": "From the first canapé to the final dance.",
    "wpage.finalH2": "Let's create your celebration together.",

    "wservices.eyebrow": "Wedding Services",
    "wservices.h2a": "Everything for your day,",
    "wservices.h2b": "beautifully handled.",
    "wservices.items": [
      { title: "Private Wedding Chef", body: "A dedicated chef creating and preparing a bespoke wedding menu for your celebration." },
      { title: "Bespoke Wedding Menus", body: "Menus designed around your tastes, guests, venue and style of wedding." },
      { title: "Canapés & Welcome Drinks", body: "Beautifully presented canapés and welcome drinks for guests as they arrive." },
      { title: "Professional Waiting Staff", body: "Experienced waiting staff to welcome guests, serve food and drinks, clear tables and help the day run smoothly." },
      { title: "Table Service", body: "Professional service throughout the meal, allowing the couple and their guests to relax and enjoy the occasion." },
      { title: "Bar & Drinks Service", body: "Drinks service arranged around your celebration, from welcome drinks and cocktails to wine and evening refreshments." },
      { title: "Table & Event Set-Up", body: "Professional preparation of dining areas, tables and service stations." },
      { title: "DJ & Music", body: "Professional DJ services to take the celebration from dinner through to the dance floor." },
      { title: "Wedding Cake", body: "Wedding cake and dessert options arranged through trusted specialist partners where required." },
      { title: "Kitchen Clean-Down", body: "We leave the kitchen clean and tidy so you can continue enjoying your celebration." },
    ],

    "wpackages.eyebrow": "Wedding Packages",
    "wpackages.h2a": "Choose the shape of",
    "wpackages.h2b": "your celebration.",
    "wpackages.badge": "Most Popular",
    "wpackages.note": "Final wedding pricing confirmed on enquiry.",
    "wpackages.items": [
      { name: "The Intimate Wedding", tagline: "For smaller, more intimate celebrations.", includes: ["Private chef", "Bespoke wedding menu", "Canapés", "Waiting staff", "Table service", "Kitchen clean-down"], featured: false },
      { name: "The Complete Wedding", tagline: "For couples who want a full dining and event experience.", includes: ["Private chef", "Bespoke wedding menu", "Canapés", "Professional waiting staff", "Bar service", "Table setup", "Table service", "Kitchen clean-down", "DJ"], featured: true },
      { name: "The Bespoke Wedding", tagline: "Your wedding. Your way.", includes: ["A completely tailored package combining food, service, drinks, entertainment and event support."], featured: false },
    ],

    "wfaqs.eyebrow": "Wedding FAQs",
    "wfaqs.items": [
      { q: "Do you travel to our wedding venue?", a: "Yes. Based in Rutland, we serve Stamford and the surrounding East Midlands, bringing the experience to your home, holiday accommodation or chosen venue." },
      { q: "Can the menu be fully bespoke?", a: "Absolutely. Every wedding menu is designed around your tastes, guests, venue and style of wedding, including dietary requirements." },
      { q: "Can you provide staff, bar and a DJ as well as the food?", a: "Yes. We can coordinate chef, canapés, waiting staff, bar service, table service, event set-up, DJ and entertainment — one team, one point of contact." },
      { q: "Are some services provided by partners?", a: "Where required, additional services such as wedding cake, entertainment and drinks can be arranged through our trusted event partners." },
      { q: "How do we get a price?", a: "Every wedding is bespoke. Tell us your date, venue, guest numbers and the services you'd like, and we'll create a tailored quote." },
    ],

    "wform.eyebrow": "Wedding Enquiry",
    "wform.h2a": "Start planning",
    "wform.h2b": "your wedding.",
    "wform.l.name": "Name", "wform.l.email": "Email", "wform.l.phone": "Phone", "wform.l.date": "Wedding Date",
    "wform.l.venue": "Venue", "wform.l.guests": "Number of Guests", "wform.l.ceremony": "Ceremony Location",
    "wform.l.reception": "Reception Location", "wform.l.style": "Wedding Style", "wform.l.budget": "Budget",
    "wform.l.food": "Food Requirements", "wform.l.dietary": "Dietary Requirements", "wform.l.services": "Services Required",
    "wform.l.info": "Additional Information",
    "wform.p.name": "Your name", "wform.p.email": "you@email.com", "wform.p.optional": "Optional", "wform.p.venue": "Venue name",
    "wform.p.guests": "e.g. 80", "wform.p.location": "Town / venue", "wform.p.style": "e.g. Rustic, elegant, relaxed",
    "wform.p.food": "Style of food / menu ideas", "wform.p.dietary": "Allergies, preferences…", "wform.p.info": "Tell us about your day…",
    "wform.services": ["Private Chef", "Canapés", "Waiting Staff", "Bar Service", "Table Service", "Table Setup", "DJ", "Entertainment", "Wedding Cake", "Other"],
    "wform.submit": "Start Planning Your Wedding",
    "wform.sending": "Sending",
    "wform.successH": "Enquiry received.",
    "wform.successP": "We'll be in touch to start planning your celebration.",
    "toast.okWedding": "Thank you — we'll be in touch to help plan your wedding.",
  },

  es: {
    "nav.home": "Inicio",
    "nav.about": "Conócenos",
    "nav.menus": "Menús",
    "nav.gallery": "Galería",
    "nav.weddings": "Bodas",
    "nav.work": "Trabaja Con Nosotros",
    "nav.quote": "Pide Presupuesto",

    "hero.eyebrow": "Cenas Privadas · Rutland y las East Midlands",
    "hero.h1a": "Cocina de chef privado,",
    "hero.h1b": "en la comodidad",
    "hero.h1c": "de tu",
    "hero.h1d": "casa.",
    "hero.sub": "Cocina española, mediterránea e italiana de calidad de restaurante, preparada exclusivamente para ti y tus invitados.",
    "hero.badge": "Con base en Rutland, sirviendo Stamford y las East Midlands",
    "hero.plan": "Planifica Tu Experiencia Privada",
    "hero.menus": "Explora Nuestros Menús",

    "chef.eyebrow": "Conoce a Tu Chef Privado",
    "chef.role": "Chef Privado y Fundador",
    "chef.p1": "Mi pasión es sencilla: crear comida excepcional y experiencias memorables para que la gente disfrute junta.",
    "chef.p2": "Mi trayectoria culinaria me ha llevado por cocinas profesionales como Sushi Social en Reikiavik, The George of Stamford, The Black Horse y The Bull en Market Deeping. Estas experiencias han moldeado mi forma de entender la cocina hoy — combinando técnica profesional con el ambiente relajado y personal de comer en casa.",
    "chef.p3": "Mediterranean Palate nació para llevarte esa experiencia directamente. Sin restaurante abarrotado, sin horarios fijos y sin pasar la noche en la cocina. Solo buena comida, tu gente favorita y una experiencia diseñada en torno a tu ocasión.",
    "chef.specialities": "Especialidades",
    "chef.specval": "Española • Mediterránea • Italiana",
    "chef.based": "Ubicación",
    "chef.basedval": "Rutland, Reino Unido",

    "occasions.items": [
      { title: "Celebraciones de Cumpleaños", body: "Celebra con comida excepcional y tu gente favorita, sin preocuparte por la cocina." },
      { title: "Despedidas de Soltera", body: "Haz que tu despedida sea memorable con una experiencia de cena privada creada especialmente para tu grupo." },
      { title: "Aniversarios", body: "Disfruta de una velada de calidad de restaurante sin salir de la comodidad de tu hogar." },
      { title: "Cenas con Invitados", body: "Pasa tiempo con tus invitados en lugar de pasar la noche en la cocina." },
      { title: "Casas Vacacionales", body: "Haz tu estancia aún más especial con una experiencia de chef privado en tu alojamiento." },
      { title: "Comidas de Empresa", body: "Una experiencia gastronómica relajada y memorable para clientes, colegas y equipos." },
    ],

    "teaser.eyebrow": "Bodas Mediterráneas",
    "teaser.h2a": "Bodas mediterráneas,",
    "teaser.h2b": "servidas a la perfección.",
    "teaser.p1": "Del primer canapé al último baile, reunimos todo lo que necesitas para una celebración de boda inolvidable.",
    "teaser.p2": "Tu boda debería sentirse sin esfuerzo. Desde canapés bellamente presentados y un menú de boda a medida hasta camareros profesionales, servicio de barra, servicio de mesa, música y animación, podemos ayudarte a unir toda tu celebración.",
    "teaser.btn": "Descubre Nuestras Bodas",

    "wflow.chips": ["Chef", "Canapés", "Camareros", "Barra", "Servicio de Mesa", "Animación", "DJ"],

    "gallery.eyebrow": "Una Muestra de Mediterranean Palate",
    "gallery.h2a": "Un vistazo a nuestra",
    "gallery.h2b": "cocina",
    "gallery.h2c": "",
    "gallery.cta1k": "Explora",
    "gallery.cta1": "Ver Nuestros Menús",
    "gallery.cta2k": "Comienza",
    "gallery.cta2": "Pide un Presupuesto",
    "gallery.cta3": "Ver Nuestra Galería",
    "gallery.cta3k": "Descubre",

    "footer.tagline": "Experiencias de Chef Privado a Domicilio",

    "wa.label": "Habla Con Tu Chef",
    "wa.msg": "Hola Santiago, me encantaría consultar sobre una experiencia de cena privada.",

    "menus.h2a": "Explora Nuestros",
    "menus.h2b": "Menús",
    "menus.bespokeH": "¿No encuentras tu menú perfecto?",
    "menus.bespokeP": "Cada experiencia puede ser completamente a medida. Cuéntanos qué buscas y crearemos algo especialmente para ti.",
    "menus.bespokeBtn": "Crear Mi Menú a Medida",
    "menucats": [
      { group: "Española y Mediterránea", items: [
        { label: "Sabores de España", id: "flavours-of-spain" },
        { label: "Tapas", id: "tapas-sharing" },
        { label: "Barbacoa Mediterránea", id: "mediterranean-bbq" },
        { label: "Menú Degustación", id: "tasting-menu" },
      ]},
      { group: "Italiana", items: [
        { label: "Menú Italiano de Cuatro Platos", id: "italian-4-course" },
        { label: "La Dolce Vita", id: "la-dolce-vita" },
      ]},
      { group: "Británica", items: [
        { label: "La Mesa Inglesa", id: "the-english-table" },
        { label: "Asado Dominical", id: "sunday-roast" },
        { label: "Barbacoa Británica Clásica", id: "classic-british-bbq" },
      ]},
      { group: "Celebraciones", items: [
        { label: "Fiesta de Canapés", id: "canape-party" },
        { label: "Mesa de Picoteo", id: "grazing-table" },
        { label: "Experiencias Vegetarianas", id: "vegetarian" },
      ]},
    ],

    "quote.eyebrow": "Planifica Tu Experiencia",
    "quote.h1a": "Planifica tu",
    "quote.h1b": "experiencia de cena privada.",
    "quote.intro": "Cuéntanos un poco sobre tu ocasión y nos pondremos en contacto para crear una experiencia a medida para ti.",
    "quote.l.name": "Nombre", "quote.l.email": "Email", "quote.l.phone": "Teléfono", "quote.l.date": "Fecha",
    "quote.l.guests": "Número de Invitados", "quote.l.occasion": "Ocasión", "quote.l.location": "Ubicación",
    "quote.l.menu": "Preferencia de Menú", "quote.l.dietary": "Requisitos Dietéticos", "quote.l.info": "Información Adicional",
    "quote.p.name": "Tu nombre", "quote.p.email": "tu@email.com", "quote.p.phone": "Opcional", "quote.p.guests": "ej. 8",
    "quote.p.occasion": "ej. Cumpleaños, Aniversario", "quote.p.location": "Ciudad / lugar",
    "quote.p.menuDefault": "No seguro / a medida", "quote.p.dietary": "Alergias, preferencias…", "quote.p.info": "Cuéntanos sobre tu ocasión…",
    "quote.submit": "Pide Tu Presupuesto a Medida",
    "quote.sending": "Enviando",
    "quote.successH": "Solicitud recibida.",
    "quote.successP": "Tu solicitud está en nuestras manos — espera pronto una nota de nuestro chef.",
    "quote.successBtn": "Enviar otra solicitud",
    "quote.thanks": "Gracias,",
    "toast.needName": "Por favor, añade tu nombre y email.",
    "toast.okQuote": "Gracias — nos pondremos en contacto para crear tu experiencia a medida.",
    "toast.err": "Algo salió mal. Inténtalo de nuevo.",

    "work.eyebrow": "Únete a la Cocina",
    "work.h1a": "Trabaja con",
    "work.h1b": "nosotros.",
    "work.intro": "Chefs, camareros y personal de barra — si compartes nuestro amor por la buena comida y la hospitalidad cálida, nos encantaría saber de ti.",
    "work.l.name": "Nombre", "work.l.email": "Email", "work.l.phone": "Número de Teléfono", "work.l.info": "Información Adicional", "work.l.cv": "Adjunta tu CV",
    "work.p.name": "Tu nombre", "work.p.email": "tu@email.com", "work.p.phone": "Tu número de teléfono",
    "work.p.info": "Tu experiencia, disponibilidad, el puesto que te interesa…", "work.p.cv": "Sube tu CV (PDF, DOC, DOCX)",
    "work.submit": "Enviar Solicitud",
    "work.successH": "Solicitud enviada.",
    "work.successP": "Hemos recibido tus datos y nos pondremos en contacto si hay un buen encaje.",
    "toast.okWork": "Gracias — tu solicitud ha sido enviada.",

    "wpage.eyebrow": "Bodas · Rutland y las East Midlands",
    "wpage.h1a": "Bodas mediterráneas,",
    "wpage.h1b": "servidas a la perfección.",
    "wpage.sub": "Del primer canapé al último baile, reunimos todo lo que necesitas para una celebración de boda inolvidable.",
    "wpage.plan": "Planifica Tu Boda",
    "wpage.introH2a": "Tu boda debería sentirse",
    "wpage.introH2b": "sin esfuerzo.",
    "wpage.introP1": "Mediterranean Palate puede ofrecer una experiencia gastronómica y de evento completa, adaptada a tu visión, tus invitados y tu lugar de celebración.",
    "wpage.introP2": "Desde canapés bellamente presentados y un menú de boda a medida hasta camareros profesionales, servicio de barra, servicio de mesa, música y animación, podemos ayudarte a unir toda tu celebración. El objetivo es sencillo: que disfrutes de tu día en lugar de preocuparte por la comida y el servicio.",
    "wpage.finalQuote": "Del primer canapé al último baile.",
    "wpage.finalH2": "Creemos tu celebración juntos.",

    "wservices.eyebrow": "Servicios de Boda",
    "wservices.h2a": "Todo para tu día,",
    "wservices.h2b": "en las mejores manos.",
    "wservices.items": [
      { title: "Chef Privado para Bodas", body: "Un chef dedicado a crear y preparar un menú de boda a medida para tu celebración." },
      { title: "Menús de Boda a Medida", body: "Menús diseñados en torno a vuestros gustos, invitados, lugar y estilo de boda." },
      { title: "Canapés y Bebidas de Bienvenida", body: "Canapés y bebidas de bienvenida bellamente presentados para los invitados a su llegada." },
      { title: "Camareros Profesionales", body: "Personal experimentado para recibir a los invitados, servir comidas y bebidas, recoger mesas y ayudar a que el día transcurra sin contratiempos." },
      { title: "Servicio de Mesa", body: "Servicio profesional durante toda la comida, para que la pareja y sus invitados se relajen y disfruten." },
      { title: "Servicio de Barra y Bebidas", body: "Servicio de bebidas adaptado a tu celebración, desde bebidas de bienvenida y cócteles hasta vino y refrescos de noche." },
      { title: "Montaje de Mesas y Evento", body: "Preparación profesional de zonas de comedor, mesas y estaciones de servicio." },
      { title: "DJ y Música", body: "Servicios profesionales de DJ para llevar la celebración de la cena a la pista de baile." },
      { title: "Tarta de Boda", body: "Opciones de tarta de boda y postres a través de socios especialistas de confianza cuando se requiera." },
      { title: "Limpieza de Cocina", body: "Dejamos la cocina limpia y ordenada para que sigas disfrutando de tu celebración." },
    ],

    "wpackages.eyebrow": "Paquetes de Boda",
    "wpackages.h2a": "Elige la forma de",
    "wpackages.h2b": "tu celebración.",
    "wpackages.badge": "El Más Popular",
    "wpackages.note": "Precio final de la boda confirmado tras la consulta.",
    "wpackages.items": [
      { name: "La Boda Íntima", tagline: "Para celebraciones más pequeñas e íntimas.", includes: ["Chef privado", "Menú de boda a medida", "Canapés", "Camareros", "Servicio de mesa", "Limpieza de cocina"], featured: false },
      { name: "La Boda Completa", tagline: "Para parejas que quieren una experiencia gastronómica y de evento completa.", includes: ["Chef privado", "Menú de boda a medida", "Canapés", "Camareros profesionales", "Servicio de barra", "Montaje de mesas", "Servicio de mesa", "Limpieza de cocina", "DJ"], featured: true },
      { name: "La Boda a Medida", tagline: "Tu boda. A tu manera.", includes: ["Un paquete completamente a medida que combina comida, servicio, bebidas, animación y apoyo al evento."], featured: false },
    ],

    "wfaqs.eyebrow": "Preguntas Frecuentes",
    "wfaqs.items": [
      { q: "¿Viajáis a nuestro lugar de celebración?", a: "Sí. Con base en Rutland, servimos Stamford y las East Midlands, llevando la experiencia a tu hogar, alojamiento vacacional o lugar elegido." },
      { q: "¿Puede el menú ser totalmente a medida?", a: "Por supuesto. Cada menú de boda se diseña en torno a vuestros gustos, invitados, lugar y estilo, incluyendo requisitos dietéticos." },
      { q: "¿Podéis proporcionar personal, barra y DJ además de la comida?", a: "Sí. Podemos coordinar chef, canapés, camareros, servicio de barra, servicio de mesa, montaje, DJ y animación — un equipo, un solo contacto." },
      { q: "¿Algunos servicios los proporcionan socios?", a: "Cuando se requiere, servicios adicionales como tarta de boda, animación y bebidas pueden organizarse a través de nuestros socios de confianza." },
      { q: "¿Cómo obtenemos un precio?", a: "Cada boda es a medida. Cuéntanos tu fecha, lugar, número de invitados y los servicios que deseas, y crearemos un presupuesto personalizado." },
    ],

    "wform.eyebrow": "Solicitud de Boda",
    "wform.h2a": "Empieza a planificar",
    "wform.h2b": "tu boda.",
    "wform.l.name": "Nombre", "wform.l.email": "Email", "wform.l.phone": "Teléfono", "wform.l.date": "Fecha de la Boda",
    "wform.l.venue": "Lugar", "wform.l.guests": "Número de Invitados", "wform.l.ceremony": "Lugar de la Ceremonia",
    "wform.l.reception": "Lugar del Banquete", "wform.l.style": "Estilo de Boda", "wform.l.budget": "Presupuesto",
    "wform.l.food": "Requisitos de Comida", "wform.l.dietary": "Requisitos Dietéticos", "wform.l.services": "Servicios Necesarios",
    "wform.l.info": "Información Adicional",
    "wform.p.name": "Tu nombre", "wform.p.email": "tu@email.com", "wform.p.optional": "Opcional", "wform.p.venue": "Nombre del lugar",
    "wform.p.guests": "ej. 80", "wform.p.location": "Ciudad / lugar", "wform.p.style": "ej. Rústico, elegante, relajado",
    "wform.p.food": "Estilo de comida / ideas de menú", "wform.p.dietary": "Alergias, preferencias…", "wform.p.info": "Cuéntanos sobre tu día…",
    "wform.services": ["Chef Privado", "Canapés", "Camareros", "Servicio de Barra", "Servicio de Mesa", "Montaje de Mesas", "DJ", "Animación", "Tarta de Boda", "Otro"],
    "wform.submit": "Empieza a Planificar Tu Boda",
    "wform.sending": "Enviando",
    "wform.successH": "Solicitud recibida.",
    "wform.successP": "Nos pondremos en contacto para empezar a planificar tu celebración.",
    "toast.okWedding": "Gracias — nos pondremos en contacto para ayudarte a planificar tu boda.",
  },
};
